import { useState, useEffect, useCallback } from "react";
import { RefreshCw, X } from "lucide-react";
import { registerSW } from "virtual:pwa-register";

export function ReloadPrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [updateSW, setUpdateSW] = useState<((reloadPage?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    const update = registerSW({
      onNeedRefresh() {
        setNeedRefresh(true);
      },
    });
    setUpdateSW(() => update);
  }, []);

  const handleReload = useCallback(() => {
    updateSW?.(true);
  }, [updateSW]);

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 sm:bottom-4 sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 z-50 bg-card border border-border shadow-lg sm:rounded-lg px-4 py-3 flex items-center gap-3 sm:max-w-sm">
      <RefreshCw className="h-5 w-5 text-primary shrink-0" />
      <p className="text-sm text-foreground flex-1">Nowa wersja dostępna</p>
      <button
        onClick={handleReload}
        className="px-3 py-1 text-sm font-medium bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors shrink-0"
      >
        Odśwież
      </button>
      <button
        onClick={() => setNeedRefresh(false)}
        className="text-muted-foreground hover:text-foreground transition-colors shrink-0"
        aria-label="Zamknij"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
